<template>
	<div>
		<Header></Header>
		<div class="problem-solving">
			<div class="problem-solving-wrap">
				<div class="problem-bg-wrap">
					<!-- <img src="../../static/img/movie.png" alt=""> -->
				</div>
				<div class="problem-solving-content">
					<span>{{ $t('videoGuidece')}}</span>
				</div>
			</div>
		</div>
		<div class="video-guidance">
			<div class="video-guidance-wrap">
				<div class="video-guidance-container">
					<h2>{{ $t('videoTitle') }} </h2>
					<div class="video-play">
						<div class="video-play-wrap">
							<div class="video-item">
								<div class="video-play-inner">
									<video src="/res/video/flash_tanix.mp4" controls poster="../../static/img/video.png"></video>
								</div>
								<div class="video-play-title">
									<span>{{ $t('videoIntroduction1')}}</span>
								</div>
							</div>
							<div class="video-item">
								<div class="video-play-inner">
									<video src="/res/video/MCPLAYER.mp4" controls poster="../../static/img/video.png"></video>
								</div>
								<div class="video-play-title">
									<span>{{ $t('videoIntroduction2')}}</span>
								</div>
							</div>
              <div class="video-item">
								<div class="video-play-inner">
									<video src="/res/video/Bluetooth.mp4" controls poster="../../static/img/video.png"></video>
								</div>
								<div class="video-play-title">
									<span>{{ $t('videoIntroduction3')}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '../header/index.vue'
	import Footer from '../footer/index.vue'
	export default {
		name: 'videoGuidance',
		components: {
			Header,
			Footer
		},
		data() {
			return {
				IMG_SERVER: 'https://static.hsyunfu.com/video/'
			};
		},
		computed: {},
		methods: {

		},
		created() {

		},
		mounted() {

		},
		updated() {},
	}
</script>
<style lang='less' scoped>
	.problem-solving {
		.problem-solving-wrap {
			position: relative;
			background: linear-gradient( 180deg, #051412 0%, #051412 70%, #4F797C 100%);
			.problem-bg-wrap {
				width: 100%;
				height: 375px;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.problem-solving-content {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);

				span {
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-weight: bold;
					font-size: 40px;
					color: #FFFFFF;
					line-height: 40px;
				}
			}
		}
	}

	.video-guidance {
		padding: 48px 0;
		color: #151515;

		.video-guidance-wrap {
			max-width: 1280px;
			padding: 0 24px;
			margin: 0 auto;
			color: #fff;

			.video-guidance-container {
				h2 {
					font-weight: bold;
					font-size: 32px;
					color: #151515;
					line-height: 38px;
				}

				h4 {
					font-size: 30px;
					font-weight: bold;
					color: #24DF94;
					line-height: 38px;
				}

				.video-play {
					.video-play-wrap {
						display: flex;
						justify-content: space-between;
						flex-wrap: wrap;
						gap: 20px;

						.video-item {
							flex: 0 0 calc(50% - 10px);
							box-sizing: border-box;
						}

						.video-play-inner {
							video {
								width: 100%;
								min-width: 320px;
								height: 360px;
							}
						}

						.video-play-title {
							padding-top: 20px;

							span {
								font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
								font-weight: 500;
								font-size: 20px;
								color: #151515;
								line-height: 24px;
							}
						}
					}
				}
			}
		}
	}
	@media (max-width: 768px){
		.video-play-wrap{
			flex-direction: column;
			.video-item{
				flex: 1;
			}
		}
	}
</style>